import { FieldErrors } from "react-hook-form";
import { adminActivityKey, getAdminSession } from "./adminSession";

export const ACCESS_TOKEN = "accessToken";
export const REFRESH_TOKEN = "refreshToken";
export const userSessionActive = (value: {
  accessToken: string;
  refreshToken: string;
}) => {
  localStorage.setItem(ACCESS_TOKEN, value.accessToken);
  localStorage.setItem(REFRESH_TOKEN, value.refreshToken);
  const session = getAdminSession(value.accessToken);
  if (
    session &&
    localStorage.getItem(adminActivityKey(session.sessionId)) === null
  ) {
    localStorage.setItem(adminActivityKey(session.sessionId), String(Date.now()));
  }
};
export const userSessionInactive = () => {
  localStorage.removeItem(ACCESS_TOKEN);
  localStorage.removeItem(REFRESH_TOKEN);
  localStorage.removeItem("persist:filters");
};

export const getError = (name: string, errors: FieldErrors) => {
  // if (!Object.keys(errors).length) return undefined;

  return name
    .split(".")
    .map((item) => item.replaceAll("[", "").replaceAll("]", ""))
    .reduce((prev, curr) => (prev ? prev[curr] : prev), errors as any);
};
